import * as React from 'react';

import {IconAvatar} from 'shells/avatar/icon-avatar';
import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {ChatbotIcon} from 'shells/icon/svg/chatbot-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {ChatbotIconEnum} from 'nutshell-graphql-types';

import styles from '../config-options/picker.module.css';

type Props = {
    type: ChatbotIconEnum;
    setType: (type: ChatbotIconEnum) => void;
};

export const DEFAULT_CHATBOT_ICONS: Partial<Record<ChatbotIconEnum, React.ReactElement<any>>> = {
    CHATBOT: <ChatbotIcon size={24} wrapWithDiv={false} />,
    SPARKLE: <AiSparkleNewIcon size={24} wrapWithDiv={false} />,
    NONE: (
        <Body size='small' color='dark'>
            None
        </Body>
    ),
};

export function ChatbotIconPicker(props: Props) {
    return (
        <Stack isHorizontal={true} spacing={8}>
            {Object.keys(DEFAULT_CHATBOT_ICONS).map((icon) => (
                <button
                    key={icon}
                    // @ts-expect-error
                    onClick={() => props.setType(icon)}
                    className={styles['icon-picker-button']}
                >
                    <IconAvatar
                        key={icon}
                        // @ts-expect-error
                        customIcon={DEFAULT_CHATBOT_ICONS[icon]}
                        avatarSize={48}
                        hasBorder={true}
                        backgroundColor={props.type === icon ? colors.blueBg : colors.white}
                        borderColor={props.type === icon ? colors.blue : colors.offWhiteDk}
                    />
                </button>
            ))}
        </Stack>
    );
}
